import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from '../../../../../authConfig';
import { Navigate } from 'react-router-dom';
import { useEffect, useRef } from 'react';

const Login = () => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const loginAttempted = useRef(false);

  useEffect(() => {
    const attemptLogin = async () => {
      // Don't attempt login if already tried or if authenticated
      if (loginAttempted.current || isAuthenticated) {
        return;
      }

      // Wait for MSAL to be ready
      if (inProgress !== InteractionStatus.None) {
        console.log('MSAL busy, waiting...', inProgress);
        return;
      }

      try {
        loginAttempted.current = true;
        console.log('Attempting automatic login redirect...');
        
        // Clear any existing interaction state first
        try {
          await instance.clearCache();
        } catch (e) {
          console.warn('Could not clear cache:', e);
        }

        await instance.loginRedirect(loginRequest);
      } catch (error) {
        console.error('Login redirect failed:', error);
        loginAttempted.current = false; // Reset so we can try again
      }
    };

    // Small delay to ensure component is fully mounted
    const timer = setTimeout(() => {
      void attemptLogin();
    }, 100);
    
    return () => {
      clearTimeout(timer);
    };
  }, [instance, inProgress, isAuthenticated]);

  // If already authenticated, redirect to home
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Show loading during authentication process
  if (inProgress !== InteractionStatus.None) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <span>Processing authentication...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <span>Redirecting to login...</span>
    </div>
  );
};

export default Login;
